__turbopack_context__.v({
  "buttonWrapper": "home-module__i0QXTG__buttonWrapper",
  "mainContent": "home-module__i0QXTG__mainContent",
});
